module.exports = __webpack_public_path__ + "static/media/Bigi.076c5c75.jpeg";